import {
    FETCH_ACCESS_POINT,
    FETCH_ACCESS_POINTS,
    FETCH_ACCESS_POINTS_FAILURE,
    FETCH_ACCESS_POINTS_SUCCESS,
    FETCH_ACCESS_POINT_FAILURE,
    FETCH_ACCESS_POINT_SUCCESS,
} from 'store/actions/types';
import utils from 'helpers/utils';

export const fetchAccessPoints = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size ? payload.size : 12,
        sort_by: payload.field ? payload.field : 'title',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'asc',
    };

    if (payload.product_id) {
        params.product_id = payload.product_id;
    }

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    return {
        type: FETCH_ACCESS_POINTS,
        payload: params,
    };
};

export const fetchAccessPointsFailure = (error) => {
    return {
        type: FETCH_ACCESS_POINTS_FAILURE,
        error: error,
    };
};

export const fetchAccessPointsSuccess = (payload) => {
    return {
        type: FETCH_ACCESS_POINTS_SUCCESS,
        payload: payload,
    };
};

export const fetchAccessPoint = (payload) => {
    return {
        type: FETCH_ACCESS_POINT,
        payload: payload,
    };
};

export const fetchAccessPointFailure = (error) => {
    return {
        type: FETCH_ACCESS_POINT_FAILURE,
        error: error,
    };
};

export const fetchAccessPointSuccess = (response) => {
    return {
        type: FETCH_ACCESS_POINT_SUCCESS,
        response: response,
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/accessPoints/fetchAccessPoints.js